import React, { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { TwitterOutlined, GithubOutlined, LinkedinOutlined, InstagramOutlined, MailOutlined } from '@ant-design/icons';
import styles from './Home.module.scss';
import { useLocation } from 'react-router-dom';
import logo from '../../assets/icons/logo-tron.png';

const cx = classNames.bind(styles);

function Home() {
    const [isVisible, setIsVisible] = useState(false);
    const [decorationsReady, setDecorationsReady] = useState(false);
    const location = useLocation();

    // Đảm bảo họa tiết được tạo trước khi component mount
    useEffect(() => {
        // Đánh dấu các họa tiết đã sẵn sàng để hiển thị
        setDecorationsReady(true);
    }, []);

    useEffect(() => {
        // Reset animation state
        setIsVisible(false);

        // Cần một chút delay để đảm bảo animation reset được thực hiện
        const timeoutId = setTimeout(() => {
            // Kích hoạt animation
            setIsVisible(true);
        }, 50);

        return () => {
            clearTimeout(timeoutId);
        };
    }, [location.pathname]); // Chạy lại mỗi khi đường dẫn thay đổi

    // Hiển thị console.log để debug
    useEffect(() => {
        if (decorationsReady) {
            console.log('Decorations ready for display');
        }
    }, [decorationsReady]);

    return (
        <div className={cx('wrap')}>
            {/* Hiển thị các họa tiết trang trí chỉ khi đã sẵn sàng */}
            {decorationsReady && (
                <>
                    {/* Thêm các họa tiết trang trí giống với trang About */}
                    <div className={cx('bg-pattern')}></div>

                    {/* Các hình trang trí */}
                    <div className={cx('decoration', 'circle-1')}></div>
                    <div className={cx('decoration', 'circle-2')}></div>
                    <div className={cx('decoration', 'circle-3')}></div>
                    <div className={cx('decoration', 'circle-4')}></div>
                    <div className={cx('decoration', 'circle-5')}></div>
                    <div className={cx('decoration', 'circle-6')}></div>
                    <div className={cx('decoration', 'triangle')}></div>
                    <div className={cx('decoration', 'triangle-2')}></div>
                    <div className={cx('decoration', 'square')}></div>
                    <div className={cx('decoration', 'square-2')}></div>
                    <div className={cx('decoration', 'line-1')}></div>
                    <div className={cx('decoration', 'line-2')}></div>
                    <div className={cx('decoration', 'dot-group-1')}>
                        <div className={cx('dot')}></div>
                        <div className={cx('dot')}></div>
                        <div className={cx('dot')}></div>
                        <div className={cx('dot')}></div>
                    </div>
                    <div className={cx('decoration', 'dot-group-2')}>
                        <div className={cx('dot')}></div>
                        <div className={cx('dot')}></div>
                        <div className={cx('dot')}></div>
                        <div className={cx('dot')}></div>
                        <div className={cx('dot')}></div>
                    </div>
                    <div className={cx('decoration', 'zigzag-1')}></div>
                    <div className={cx('decoration', 'zigzag-2')}></div>
                    <div className={cx('decoration', 'star-1')}></div>
                    <div className={cx('decoration', 'star-2')}></div>
                    <div className={cx('decoration', 'diamond-1')}></div>
                    <div className={cx('decoration', 'diamond-2')}></div>
                </>
            )}

            <div className={cx('container')}>
                <div className={cx('content', { 'animate-content': isVisible })}>
                    <div className={cx('intro-line')}></div>
                    <h1 className={cx('title')}>
                        <div className={cx('title-line', { animate: isVisible })}>
                            tôi là <span className={cx('name')}>Nguyễn Mạnh Phương</span>,
                        </div>
                        <div className={cx('title-line', { animate: isVisible, 'delay-1': isVisible })}>
                            <span className={cx('highlight')}>Fullstack Developer</span>
                        </div>
                    </h1>
                    <p className={cx('description', { animate: isVisible, 'delay-2': isVisible })}>
                        Tôi tập trung vào việc phát triển các ứng dụng web hiệu quả, an toàn và mang lại trải nghiệm
                        người dùng tối ưu, không ngừng học hỏi để nâng cao chất lượng sản phẩm.
                    </p>

                    {/* Social Media Icons Section */}
                    <div className={cx('social-links', { animate: isVisible, 'delay-3': isVisible })}>
                        <div
                            // href="https://twitter.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={cx('social-icon')}
                        >
                            <TwitterOutlined />
                        </div>
                        <a
                            href="https://github.com/Manh-Phuong"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={cx('social-icon')}
                        >
                            <GithubOutlined />
                        </a>
                        <a
                            href="https://www.linkedin.com/in/manh-phuong/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={cx('social-icon')}
                        >
                            <LinkedinOutlined />
                        </a>
                        <div
                            // href="https://instagram.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={cx('social-icon')}
                        >
                            <InstagramOutlined />
                        </div>
                        <a href="mailto:manhphuong.dev@gmail.com" className={cx('social-icon')}>
                            <MailOutlined />
                        </a>
                    </div>
                </div>
                <div className={cx('image-container', { 'animate-image': isVisible })}>
                    <div className={cx('image-circle')}>
                        {/* <span className={cx('image-text')}>chủ portfolio</span> */}
                        <img src={logo} alt="Logo" className={cx('image-content')} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;
